var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "upcoming-events-carousel__card",
      attrs: {
        "data-category": "event-card",
        "data-type": _vm.event.eventTypes.name,
      },
    },
    [
      _c("div", { staticClass: "upcoming-events-carousel__card-wrapper" }, [
        _c(
          "picture",
          {
            directives: [
              {
                name: "lazyload",
                rawName: "v-lazyload",
                value: {
                  src: _vm.event.eventImage,
                  variant: "default",
                  updateCallback: _vm.imageLoadedEvent,
                  canLoad: _vm.canLoad,
                },
                expression:
                  "{\n        src: event.eventImage,\n        variant: 'default',\n        updateCallback: imageLoadedEvent,\n        canLoad,\n      }",
              },
            ],
            staticClass: "upcoming-events-carousel__image image-wrapper",
          },
          [
            _c("img", {
              staticClass: "image",
              attrs: {
                src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                alt: _vm.event.eventImageAlt,
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "upcoming-events-carousel__container" }, [
          _c("div", { staticClass: "upcoming-events-carousel__info" }, [
            _vm.event.eventTypes && _vm.event.eventTypes.name
              ? _c("span", { staticClass: "upcoming-events-carousel__tag" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.event.eventTypes.name) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "upcoming-events-carousel__eyebrown" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.eventEyebrownLabel) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "upcoming-events-carousel__title" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.event.eventTitle) + "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "upcoming-events-carousel__description",
              attrs: { id: "desc-" + _vm.event.eventId },
              domProps: { innerHTML: _vm._s(_vm.truncatedDescription) },
            }),
            _vm._v(" "),
            _vm.descriptionShouldBeTruncated
              ? _c(
                  "button",
                  {
                    staticClass: "upcoming-events-carousel__description-cta",
                    class: {
                      more: !_vm.showFullDescription,
                      less: _vm.showFullDescription,
                    },
                    attrs: {
                      type: "button",
                      "data-category": "toggle-description",
                      "data-state": _vm.showFullDescription
                        ? "expanded"
                        : "collapsed",
                      "aria-expanded": _vm.showFullDescription,
                      "aria-controls": "desc-" + _vm.event.eventId,
                    },
                    on: {
                      click: _vm.toggleDescriptionVisibility,
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.toggleDescriptionVisibility($event)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.toggleDescriptionVisibility($event)
                        },
                      ],
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.showFullDescription
                            ? _vm.dictionary["upcoming-events:see-less"]
                            : _vm.dictionary["upcoming-events:see-more"]
                        ) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.event.additionalDates.length
              ? _c(
                  "h4",
                  { staticClass: "upcoming-events-carousel__date-title" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.dictionary["upcoming-events:additional-dates"]
                        ) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.event.additionalDates.length
              ? _c(
                  "ul",
                  { staticClass: "upcoming-events-carousel__date-list" },
                  _vm._l(_vm.event.additionalDates, function (date, index) {
                    return _c(
                      "li",
                      {
                        key: "event-date-" + _vm.event.eventId + "-" + index,
                        staticClass: "upcoming-events-carousel__date-item",
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.eventDayOfWeek(date.eventStartDate))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.eventMonthDay(date.eventStartDate))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "upcoming-events-carousel__date-item-time",
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(date.eventStartTime) +
                                " " +
                                _vm._s(
                                  date.eventEndTime
                                    ? "- " + date.eventEndTime
                                    : ""
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "upcoming-events-carousel__ctas" }, [
            _vm.event.secondaryCtaUrl && _vm.event.secondaryCtaLabel
              ? _c(
                  "a",
                  {
                    staticClass: "button--secondary black size-md outlined",
                    attrs: {
                      href: _vm.event.secondaryCtaUrl,
                      target: _vm.event.secondaryCtaTarget,
                      "data-category": "cta",
                      "data-cta": _vm.toCamelCase(_vm.event.secondaryCtaLabel),
                    },
                  },
                  [_vm._v(_vm._s(_vm.event.secondaryCtaLabel))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.event.primaryCtaUrl && _vm.event.primaryCtaLabel
              ? _c(
                  "a",
                  {
                    staticClass: "button--primary black size-md",
                    attrs: {
                      href: _vm.event.primaryCtaUrl,
                      target: _vm.event.primaryCtaTarget,
                      "data-category": "cta",
                      "data-cta": _vm.toCamelCase(_vm.event.primaryCtaLabel),
                    },
                  },
                  [_vm._v(_vm._s(_vm.event.primaryCtaLabel))]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }